module.exports = __webpack_public_path__ + "static/media/apple-button-over.1224e23f.svg";